module.exports = __webpack_public_path__ + "static/media/connected_icon.b7109973.svg";